/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 34:
/***/ ((module) => {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ 729:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(548), __webpack_require__(498)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, AdWrapper_1, types_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.AdType = exports.AdEvents = exports.ProviderTypes = exports.GameDistributionBannerSize = exports.GameDistributionAlignment = exports.AdWrapper = void 0;
    Object.defineProperty(exports, "AdWrapper", ({ enumerable: true, get: function () { return AdWrapper_1.AdWrapper; } }));
    Object.defineProperty(exports, "GameDistributionAlignment", ({ enumerable: true, get: function () { return types_1.GameDistributionAlignment; } }));
    Object.defineProperty(exports, "GameDistributionBannerSize", ({ enumerable: true, get: function () { return types_1.GameDistributionBannerSize; } }));
    Object.defineProperty(exports, "ProviderTypes", ({ enumerable: true, get: function () { return types_1.ProviderTypes; } }));
    Object.defineProperty(exports, "AdEvents", ({ enumerable: true, get: function () { return types_1.AdEvents; } }));
    Object.defineProperty(exports, "AdType", ({ enumerable: true, get: function () { return types_1.AdType; } }));
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 470:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, shared_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.JioAdProvider = void 0;
    var JioAdProvider = /** @class */ (function () {
        function JioAdProvider(config) {
            this.adsEnabled = false;
            var adSpotInterstitial = config.adSpotInterstitial, adSpotRewardedVideo = config.adSpotRewardedVideo, gamePackage = config.gamePackage;
            try {
                window.adSpotInterstitial = adSpotInterstitial; // AdSpot ID for midRoll Interstitial
                window.adSpotRewardedVideo = adSpotRewardedVideo; //AdSpot ID for Rewarded Video0
                window.isAdReady = false;
                window.isRVReady = false;
                window.isINSReady = false;
                window.gamePackage = gamePackage; // The package name of your game
            }
            catch (err) {
                console.log('Could not initialize Jio Games SDK', err);
            }
        }
        JioAdProvider.prototype.setManager = function (manager) {
            this.adManager = manager;
        };
        JioAdProvider.prototype.showAd = function (adType, adSpotKey) {
            var _this = this;
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            if (!this.adAvailable(adType)) {
                console.log('Cannot show Jio ads; Ads were not preloaded or failed to load. Resuming game');
                this.resumeGameplay();
                return;
            }
            if (window.hasOwnProperty('onAdClosed') && typeof (window['onAdClosed'] === 'function')) {
                window['onAdClosed'] = function (data, pIsVideoCompleted, pIsEligibleForReward) {
                    var localData = data.split(',');
                    var closedAdSpotKey = data;
                    var isVideoCompleted = pIsVideoCompleted;
                    var isEligibleForReward = pIsEligibleForReward;
                    if (localData != null && localData.length > 1) {
                        closedAdSpotKey = localData[0].trim();
                        isVideoCompleted = Boolean(localData[1].trim());
                        isEligibleForReward = Boolean(localData[2].trim());
                    }
                    if (closedAdSpotKey === window.adSpotInterstitial) {
                        window.isAdReady = false;
                    }
                    if (closedAdSpotKey === window.adSpotRewardedVideo) {
                        window.isRVReady = false;
                        if (isEligibleForReward && isVideoCompleted) {
                            _this.adManager.emit(shared_1.AdEvents.AD_REWARDED);
                        }
                    }
                    setTimeout(function () {
                        console.log('JioGames ads: onAdClose');
                        _this.resumeGameplay();
                    }, 3000);
                };
            }
            if (adType === shared_1.AdType.interstitial) {
                if (window.hasOwnProperty('showAdMidRoll') && typeof (window['showAdMidRoll'] === 'function')) {
                    try {
                        window.adSpotInterstitial = adSpotKey;
                        window['showAdMidRoll'](adSpotKey, window.gamePackage);
                    }
                    catch (e) {
                        this.resumeGameplay();
                        console.log('Error caching midroll ads');
                    }
                }
            }
            if (adType === shared_1.AdType.rewarded) {
                if (window.hasOwnProperty('showAdRewardedVideo') && typeof (window['showAdRewardedVideo'] === 'function')) {
                    try {
                        window.adSpotRewardedVideo = adSpotKey;
                        window['showAdRewardedVideo'](adSpotKey, window.gamePackage);
                    }
                    catch (e) {
                        this.resumeGameplay();
                        console.log('Error caching midroll ads');
                    }
                }
            }
        };
        JioAdProvider.prototype.resumeGameplay = function () {
            this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
        };
        //Does nothing, but needed for Provider interface
        JioAdProvider.prototype.preloadAd = function (adType, adSpotKey) {
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            console.log('Calling cache Jio Ad');
            if (adType === shared_1.AdType.interstitial) {
                if (window.hasOwnProperty('cacheAdMidRoll') && typeof (window['cacheAdMidRoll'] === 'function')) {
                    try {
                        window.adSpotInterstitial = adSpotKey;
                        window['cacheAdMidRoll'](adSpotKey, window.gamePackage);
                    }
                    catch (e) {
                        console.log('Error caching midroll ads');
                    }
                }
            }
            if (adType === shared_1.AdType.rewarded) {
                if (window.hasOwnProperty('cacheAdRewardedVideo') && typeof (window['cacheAdRewardedVideo'] === 'function')) {
                    try {
                        window.adSpotRewardedVideo = adSpotKey;
                        window['cacheAdRewardedVideo'](adSpotKey, window.gamePackage);
                    }
                    catch (e) {
                        console.log('Error caching rewarded ads');
                    }
                }
            }
            if (window.hasOwnProperty('onAdPrepared') && typeof (window['onAdPrepared'] === 'function')) {
                window['onAdPrepared'] = function (preparedAdSpotKey) {
                    try {
                        if (preparedAdSpotKey === window.adSpotInterstitial) {
                            window.isAdReady = true;
                        }
                        if (preparedAdSpotKey === window.adSpotRewardedVideo) {
                            window.isRVReady = true;
                        }
                    }
                    catch (e) {
                        console.log('Error caching Jio rewarded ads');
                    }
                };
            }
            if (window.hasOwnProperty('onAdFailedToLoad') && typeof (window['onAdFailedToLoad'] === 'function')) {
                window['onAdFailedToLoad'] = function (data, pDescription) {
                    var localData = data.split(',');
                    var failedAdSpotKey = data;
                    var description = pDescription;
                    if (localData != null && localData.length > 1) {
                        failedAdSpotKey = localData[0].trim();
                        description = localData[1].trim();
                    }
                    try {
                        if (failedAdSpotKey === window.adSpotInterstitial) {
                            window.isAdReady = false;
                        }
                        if (failedAdSpotKey === window.adSpotRewardedVideo) {
                            window.isRVReady = false;
                        }
                        console.log("JioGames: onAdFailedToLoad => ".concat(data.toString(), " => ").concat(description));
                    }
                    catch (e) {
                        console.log('Error loading Jio ads');
                    }
                };
            }
        };
        //Does nothing, but needed for Provider interface
        JioAdProvider.prototype.destroyAd = function () {
            return;
        };
        //Does nothing, but needed for Provider interface
        JioAdProvider.prototype.hideAd = function () {
            return;
        };
        JioAdProvider.prototype.adAvailable = function (adType) {
            if (adType === shared_1.AdType.rewarded) {
                return window.isRVReady;
            }
            else if (adType === shared_1.AdType.interstitial) {
                return window.isAdReady;
            }
            return false;
        };
        return JioAdProvider;
    }());
    exports.JioAdProvider = JioAdProvider;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 766:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(470)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, JioAdProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.JioAdProvider = void 0;
    Object.defineProperty(exports, "JioAdProvider", ({ enumerable: true, get: function () { return JioAdProvider_1.JioAdProvider; } }));
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 110:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, shared_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.AdFreeUntrackedProvider = void 0;
    var AdFreeUntrackedProvider = /** @class */ (function () {
        function AdFreeUntrackedProvider() {
            this.adsEnabled = false;
        }
        AdFreeUntrackedProvider.prototype.setManager = function (manager) {
            this.adManager = manager;
        };
        AdFreeUntrackedProvider.prototype.showAd = function (adType) {
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            this.resumeGameplay();
        };
        AdFreeUntrackedProvider.prototype.resumeGameplay = function () {
            this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
        };
        //Does nothing, but needed for Provider interface
        AdFreeUntrackedProvider.prototype.preloadAd = function (adType) {
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            return;
        };
        //Does nothing, but needed for Provider interface
        AdFreeUntrackedProvider.prototype.destroyAd = function () {
            return;
        };
        //Does nothing, but needed for Provider interface
        AdFreeUntrackedProvider.prototype.hideAd = function () {
            return;
        };
        AdFreeUntrackedProvider.prototype.adAvailable = function (adType) {
            return true;
        };
        return AdFreeUntrackedProvider;
    }());
    exports.AdFreeUntrackedProvider = AdFreeUntrackedProvider;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 670:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, shared_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.DummyProvider = void 0;
    var DummyProvider = /** @class */ (function () {
        function DummyProvider() {
            this.adsEnabled = false;
        }
        DummyProvider.prototype.setManager = function (manager) {
            this.adManager = manager;
            this.adsEnabled = true;
        };
        DummyProvider.prototype.showAd = function (adType) {
            var _this = this;
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            console.log('[Dummy]: Ad type requested = ', adType === shared_1.AdType.interstitial ? 'interstitial' : 'rewarded');
            this.adManager.emit(shared_1.AdEvents.CONTENT_PAUSED);
            var num = Math.floor(Math.random() * 2);
            console.log('[Dummy]:Ad Available =>', num === 0);
            if (num === 1) {
                console.log('[Dummy]:AD ERROR / UNAVAILABLE');
                setTimeout(function () {
                    console.log('[Dummy]: Resuming game');
                    _this.resumeGameplay();
                }, 200);
            }
            else {
                if (adType === shared_1.AdType.rewarded) {
                    setTimeout(function () {
                        console.log('[Dummy]: Reward Claimed for rewarded ad');
                        _this.adManager.emit(shared_1.AdEvents.AD_REWARDED);
                    }, 100);
                }
                setTimeout(function () {
                    console.log('[Dummy]: Finished watching ad');
                    console.log('[Dummy]: Resuming game');
                    _this.resumeGameplay();
                }, 200);
            }
        };
        DummyProvider.prototype.resumeGameplay = function () {
            this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
        };
        //Does nothing, but needed for Provider interface
        DummyProvider.prototype.preloadAd = function (adType) {
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            return;
        };
        //Does nothing, but needed for Provider interface
        DummyProvider.prototype.destroyAd = function () {
            return;
        };
        //Does nothing, but needed for Provider interface
        DummyProvider.prototype.hideAd = function () {
            return;
        };
        DummyProvider.prototype.adAvailable = function (adType) {
            return true;
        };
        return DummyProvider;
    }());
    exports.DummyProvider = DummyProvider;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 474:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, shared_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.GameDistribution = exports.GameDistributionAdType = void 0;
    var GameDistributionAdType;
    (function (GameDistributionAdType) {
        GameDistributionAdType["interstitial"] = "interstitial";
        GameDistributionAdType["rewarded"] = "rewarded";
        GameDistributionAdType["display"] = "display";
    })(GameDistributionAdType = exports.GameDistributionAdType || (exports.GameDistributionAdType = {}));
    var GameDistribution = /** @class */ (function () {
        function GameDistribution(gameId) {
            var _this = this;
            this.adsEnabled = false;
            this.hasRewarded = false;
            this.adShowing = false;
            if (!gameId) {
                throw new Error('Valid game id is not provided for GD Ad provider');
            }
            window.GD_OPTIONS = {
                gameId: gameId,
                advertisementSettings: {
                    autoplay: false
                },
                onEvent: function (event) {
                    switch (event.name) {
                        case 'SDK_GAME_PAUSE':
                            // pause game logic / mute audio
                            _this.adManager.emit(shared_1.AdEvents.CONTENT_PAUSED);
                            break;
                        case 'SDK_ERROR':
                            // when ad has an error
                            _this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
                            break;
                        case 'SDK_READY':
                            _this.sdkLoaded();
                            break;
                        case 'SDK_REWARDED_WATCH_COMPLETE':
                            // this event is triggered when your user completely watched rewarded ad
                            _this.adManager.emit(shared_1.AdEvents.AD_REWARDED);
                            _this.hasRewarded = false;
                            break;
                        default:
                            break;
                    }
                }
            };
            //Include script. even when adblock is enabled, this script also allows us to track our users;
            (function (d, s, id) {
                var js;
                var fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = '//html5.api.gamedistribution.com/main.min.js';
                if (fjs.parentNode) {
                    fjs.parentNode.insertBefore(js, fjs);
                }
            })(document, 'script', 'gamedistribution-jssdk');
        }
        GameDistribution.prototype.setManager = function (manager) {
            this.adManager = manager;
            this.adManager.emit(shared_1.AdEvents.AD_PROVIDER_LOADED);
        };
        GameDistribution.prototype.sdkLoaded = function () {
            this.adsEnabled = true;
        };
        GameDistribution.prototype.showAd = function (adType) {
            var _this = this;
            if (!this.adsEnabled) {
                this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
            }
            else {
                if (typeof window.gdsdk === 'undefined' || (window.gdsdk && typeof window.gdsdk.showAd === 'undefined')) {
                    //So gdsdk isn't available OR
                    //gdsdk is available, but showBanner is not there (weird but can happen)
                    this.adsEnabled = false;
                    this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
                    return;
                }
                window.gdsdk
                    .showAd(adType === shared_1.AdType.rewarded
                    ? GameDistributionAdType.rewarded
                    : GameDistributionAdType.interstitial)
                    .then(function () {
                    _this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
                })
                    .catch(function () {
                    if (adType === shared_1.AdType.rewarded && _this.hasRewarded) {
                        _this.hasRewarded = false;
                    }
                    _this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
                });
            }
        };
        //Does nothing, but needed for Provider interface
        GameDistribution.prototype.preloadAd = function (adType) {
            var _this = this;
            if (this.hasRewarded || !this.adsEnabled || adType !== shared_1.AdType.rewarded) {
                return;
            }
            console.log('preloading ad');
            window.gdsdk.preloadAd(GameDistributionAdType.rewarded).then(function () {
                _this.hasRewarded = true;
                _this.adManager.emit(shared_1.AdEvents.AD_LOADED, adType);
            });
        };
        GameDistribution.prototype.adAvailable = function (adType) {
            if (adType === shared_1.AdType.rewarded) {
                return this.hasRewarded;
            }
            return true;
        };
        //Does nothing, but needed for Provider interface
        GameDistribution.prototype.destroyAd = function () {
            return;
        };
        //Does nothing, but needed for Provider interface
        GameDistribution.prototype.hideAd = function () {
            return;
        };
        return GameDistribution;
    }());
    exports.GameDistribution = GameDistribution;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 444:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(474), __webpack_require__(869)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, GameDistribution_1, gamedistribution_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.GameDistributionBanner = void 0;
    var GameDistributionBanner = /** @class */ (function () {
        function GameDistributionBanner() {
            this.scaleFactor = 1;
            this.offsetX = 0;
            this.offsetY = 0;
            this.element = document.createElement('div');
            this.element.style.position = 'absolute';
            this.element.style.top = "0px";
            this.element.style.left = "0px";
            this.element.id = "banner-".concat(Date.now()).concat((Math.random() * 10000000) | 0);
            document.body.appendChild(this.element);
        }
        GameDistributionBanner.prototype.loadBanner = function () {
            if (typeof window.gdsdk === 'undefined') {
                return Promise.reject('GD Sdk not available, probably due to adblocker');
            }
            return window.gdsdk.showAd(GameDistribution_1.GameDistributionAdType.display, {
                containerId: this.element.id
            });
        };
        GameDistributionBanner.prototype.destroy = function () {
            document.body.removeChild(this.element);
            if (this.resizeListener) {
                window.removeEventListener('resize', this.resizeListener);
            }
            delete this.element;
            delete this.parent;
            delete this.alignment;
        };
        GameDistributionBanner.prototype.alignIn = function (element, position) {
            var _this = this;
            if (this.parent) {
                console.warn('Banner already aligned, ignoring...');
                return;
            }
            this.parent = element;
            this.alignment = position;
            this.resizeListener = function () { return _this.resize(); };
            window.addEventListener('resize', this.resizeListener);
            this.resize();
        };
        GameDistributionBanner.prototype.setOffset = function (x, y) {
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            this.offsetX = x;
            this.offsetY = y;
            this.resize();
        };
        //todo this is legacy setup, this needs to be cleaned up and set up differently
        GameDistributionBanner.prototype.resize = function () {
            if (!this.parent) {
                return;
            }
            var parentBoundingRect = this.parent.getBoundingClientRect();
            switch (this.alignment) {
                case gamedistribution_1.GameDistributionAlignment.TopLeft:
                    this.position(parentBoundingRect.left, parentBoundingRect.top);
                    break;
                case gamedistribution_1.GameDistributionAlignment.TopCenter:
                    this.position(parentBoundingRect.left +
                        parentBoundingRect.width / 2 -
                        (this.width * this.scaleFactor) / 2, parentBoundingRect.top);
                    break;
                case gamedistribution_1.GameDistributionAlignment.TopRight:
                    this.position(parentBoundingRect.left +
                        parentBoundingRect.width -
                        this.width * this.scaleFactor, parentBoundingRect.top);
                    break;
                case gamedistribution_1.GameDistributionAlignment.CenterLeft:
                    this.position(parentBoundingRect.left, parentBoundingRect.top +
                        parentBoundingRect.height / 2 -
                        (this.height * this.scaleFactor) / 2);
                    break;
                case gamedistribution_1.GameDistributionAlignment.Center:
                    this.position(parentBoundingRect.left +
                        parentBoundingRect.width / 2 -
                        (this.width * this.scaleFactor) / 2, parentBoundingRect.top +
                        parentBoundingRect.height / 2 -
                        (this.height * this.scaleFactor) / 2);
                    break;
                case gamedistribution_1.GameDistributionAlignment.CenterRight:
                    this.position(parentBoundingRect.left +
                        parentBoundingRect.width -
                        this.width * this.scaleFactor, parentBoundingRect.top +
                        parentBoundingRect.height / 2 -
                        (this.height * this.scaleFactor) / 2);
                    break;
                case gamedistribution_1.GameDistributionAlignment.BottomLeft:
                    this.position(parentBoundingRect.left, parentBoundingRect.top +
                        parentBoundingRect.height -
                        this.height * this.scaleFactor);
                    break;
                case gamedistribution_1.GameDistributionAlignment.BottomCenter:
                    this.position(parentBoundingRect.left +
                        parentBoundingRect.width / 2 -
                        (this.width * this.scaleFactor) / 2, parentBoundingRect.top +
                        parentBoundingRect.height -
                        this.height * this.scaleFactor);
                    break;
                case gamedistribution_1.GameDistributionAlignment.BottomRight:
                    this.position(parentBoundingRect.left +
                        parentBoundingRect.width -
                        this.width * this.scaleFactor, parentBoundingRect.top +
                        parentBoundingRect.height -
                        this.height * this.scaleFactor);
                    break;
            }
        };
        GameDistributionBanner.prototype.setSize = function (size) {
            var width;
            var height;
            switch (size) {
                default:
                case gamedistribution_1.GameDistributionBannerSize.LargeRectangle:
                    width = 336;
                    height = 280;
                    break;
                case gamedistribution_1.GameDistributionBannerSize.MediumRectangle:
                    width = 300;
                    height = 250;
                    break;
                case gamedistribution_1.GameDistributionBannerSize.Billboard:
                    width = 970;
                    height = 250;
                    break;
                case gamedistribution_1.GameDistributionBannerSize.Leaderboard:
                    width = 728;
                    height = 90;
                    break;
                case gamedistribution_1.GameDistributionBannerSize.Skyscraper:
                    width = 120;
                    height = 600;
                    break;
                case gamedistribution_1.GameDistributionBannerSize.WideSkyscraper:
                    width = 160;
                    height = 600;
                    break;
            }
            this.width = width;
            this.height = height;
            this.element.style.width = "".concat(width, "px");
            this.element.style.height = "".concat(height, "px");
        };
        GameDistributionBanner.prototype.position = function (x, y) {
            this.element.style.left = "".concat(x + this.offsetX, "px");
            this.element.style.top = "".concat(y + this.offsetY, "px");
        };
        GameDistributionBanner.prototype.scale = function (factor) {
            this.element.style.transformOrigin = 'left top';
            this.scaleFactor = factor;
            this.element.style.transform = "scale(".concat(factor, ")");
        };
        return GameDistributionBanner;
    }());
    exports.GameDistributionBanner = GameDistributionBanner;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 654:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, shared_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.YandexAdProvider = void 0;
    var YandexAdProvider = /** @class */ (function () {
        function YandexAdProvider(partnerID) {
            var _this = this;
            this.adsEnabled = false;
            //Include script. even when adblock is enabled, this script also allows us to track our users;
            (function (d, s, id) {
                var js;
                var fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.addEventListener('load', function () {
                    _this.initialize();
                });
                js.id = id;
                js.src = '//yandex.ru/games/sdk/v2';
                fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'yandex-jssdk');
        }
        YandexAdProvider.prototype.setManager = function (manager) {
            this.adManager = manager;
        };
        YandexAdProvider.prototype.showAd = function (adType) {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            if (!this.adsEnabled || !window.hasOwnProperty('_YaSDK')) {
                this.resumeGameplay();
                return;
            }
            if (adType === shared_1.AdType.interstitial && ((_b = (_a = window._YaSDK) === null || _a === void 0 ? void 0 : _a.adv) === null || _b === void 0 ? void 0 : _b.adOpened)) {
                return;
            }
            if (adType === shared_1.AdType.rewarded) {
                (_e = (_d = (_c = window._YaSDK) === null || _c === void 0 ? void 0 : _c.adv) === null || _d === void 0 ? void 0 : _d.showRewardedVideo) === null || _e === void 0 ? void 0 : _e.call(_d, {
                    callbacks: {
                        onOpen: function () {
                            console.log('Video ad open.');
                            _this.adManager.emit(shared_1.AdEvents.CONTENT_PAUSED);
                        },
                        onRewarded: function () {
                            console.log('Rewarded!');
                            _this.adManager.emit(shared_1.AdEvents.AD_REWARDED);
                        },
                        onClose: function () {
                            console.log('Video ad closed.');
                            _this.resumeGameplay();
                        },
                        onError: function (e) {
                            console.log('Error while open video ad:', e);
                            _this.resumeGameplay();
                        }
                    }
                });
            }
            else {
                (_h = (_g = (_f = window._YaSDK) === null || _f === void 0 ? void 0 : _f.adv) === null || _g === void 0 ? void 0 : _g.showFullscreenAdv) === null || _h === void 0 ? void 0 : _h.call(_g, {
                    callbacks: {
                        onOpen: function () {
                            console.log('Video ad open.');
                            _this.adManager.emit(shared_1.AdEvents.CONTENT_PAUSED);
                        },
                        onClose: function () {
                            _this.resumeGameplay();
                        },
                        onError: function () {
                            _this.resumeGameplay();
                        }
                    }
                });
            }
        };
        YandexAdProvider.prototype.initialize = function () {
            var _this = this;
            window.YaGames.init().then(function (ysdk) {
                window._YaSDK = ysdk;
                _this.adsEnabled = true;
            });
        };
        YandexAdProvider.prototype.resumeGameplay = function () {
            this.adManager.emit(shared_1.AdEvents.CONTENT_RESUMED);
        };
        //Does nothing, but needed for Provider interface
        YandexAdProvider.prototype.preloadAd = function (adType) {
            if (adType === void 0) { adType = shared_1.AdType.interstitial; }
            this.adManager.emit(shared_1.AdEvents.AD_LOADED, adType);
        };
        //Does nothing, but needed for Provider interface
        YandexAdProvider.prototype.destroyAd = function () {
            return;
        };
        //Does nothing, but needed for Provider interface
        YandexAdProvider.prototype.hideAd = function () {
            return;
        };
        YandexAdProvider.prototype.adAvailable = function (adType) {
            return true;
        };
        return YandexAdProvider;
    }());
    exports.YandexAdProvider = YandexAdProvider;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 563:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(110), __webpack_require__(670), __webpack_require__(474), __webpack_require__(444), __webpack_require__(654)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, AdFreeUntrackedProvider_1, DummyProvider_1, GameDistribution_1, GameDistributionBanner_1, YandexAdProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.YandexAdProvider = exports.GameDistributionBanner = exports.GameDistribution = exports.DummyProvider = exports.AdFreeUntrackedProvider = void 0;
    Object.defineProperty(exports, "AdFreeUntrackedProvider", ({ enumerable: true, get: function () { return AdFreeUntrackedProvider_1.AdFreeUntrackedProvider; } }));
    Object.defineProperty(exports, "DummyProvider", ({ enumerable: true, get: function () { return DummyProvider_1.DummyProvider; } }));
    Object.defineProperty(exports, "GameDistribution", ({ enumerable: true, get: function () { return GameDistribution_1.GameDistribution; } }));
    Object.defineProperty(exports, "GameDistributionBanner", ({ enumerable: true, get: function () { return GameDistributionBanner_1.GameDistributionBanner; } }));
    Object.defineProperty(exports, "YandexAdProvider", ({ enumerable: true, get: function () { return YandexAdProvider_1.YandexAdProvider; } }));
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 869:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.GameDistributionAlignment = exports.GameDistributionBannerSize = void 0;
    var GameDistributionBannerSize;
    (function (GameDistributionBannerSize) {
        GameDistributionBannerSize[GameDistributionBannerSize["LargeRectangle"] = 0] = "LargeRectangle";
        GameDistributionBannerSize[GameDistributionBannerSize["MediumRectangle"] = 1] = "MediumRectangle";
        GameDistributionBannerSize[GameDistributionBannerSize["Billboard"] = 2] = "Billboard";
        GameDistributionBannerSize[GameDistributionBannerSize["Leaderboard"] = 3] = "Leaderboard";
        GameDistributionBannerSize[GameDistributionBannerSize["Skyscraper"] = 4] = "Skyscraper";
        GameDistributionBannerSize[GameDistributionBannerSize["WideSkyscraper"] = 5] = "WideSkyscraper"; // 160x600
    })(GameDistributionBannerSize = exports.GameDistributionBannerSize || (exports.GameDistributionBannerSize = {}));
    var GameDistributionAlignment;
    (function (GameDistributionAlignment) {
        GameDistributionAlignment[GameDistributionAlignment["TopLeft"] = 0] = "TopLeft";
        GameDistributionAlignment[GameDistributionAlignment["TopCenter"] = 1] = "TopCenter";
        GameDistributionAlignment[GameDistributionAlignment["TopRight"] = 2] = "TopRight";
        GameDistributionAlignment[GameDistributionAlignment["CenterLeft"] = 3] = "CenterLeft";
        GameDistributionAlignment[GameDistributionAlignment["Center"] = 4] = "Center";
        GameDistributionAlignment[GameDistributionAlignment["CenterRight"] = 5] = "CenterRight";
        GameDistributionAlignment[GameDistributionAlignment["BottomLeft"] = 6] = "BottomLeft";
        GameDistributionAlignment[GameDistributionAlignment["BottomCenter"] = 7] = "BottomCenter";
        GameDistributionAlignment[GameDistributionAlignment["BottomRight"] = 8] = "BottomRight";
    })(GameDistributionAlignment = exports.GameDistributionAlignment || (exports.GameDistributionAlignment = {}));
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 498:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(12), __webpack_require__(869)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, shared_1, gamedistribution_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.GameDistributionAlignment = exports.GameDistributionBannerSize = exports.ProviderTypes = exports.AdType = exports.AdEvents = void 0;
    Object.defineProperty(exports, "AdEvents", ({ enumerable: true, get: function () { return shared_1.AdEvents; } }));
    Object.defineProperty(exports, "AdType", ({ enumerable: true, get: function () { return shared_1.AdType; } }));
    Object.defineProperty(exports, "ProviderTypes", ({ enumerable: true, get: function () { return shared_1.ProviderTypes; } }));
    Object.defineProperty(exports, "GameDistributionBannerSize", ({ enumerable: true, get: function () { return gamedistribution_1.GameDistributionBannerSize; } }));
    Object.defineProperty(exports, "GameDistributionAlignment", ({ enumerable: true, get: function () { return gamedistribution_1.GameDistributionAlignment; } }));
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 12:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.ProviderTypes = exports.AdType = exports.AdEvents = void 0;
    var AdEvents;
    (function (AdEvents) {
        AdEvents["CONTENT_PAUSED"] = "onContentPaused";
        AdEvents["CONTENT_RESUMED"] = "onContentResumed";
        AdEvents["AD_PROGRESSION"] = "onAdProgression";
        AdEvents["AD_DISABLED"] = "onAdsDisabled";
        AdEvents["AD_CLICKED"] = "onAdClicked";
        AdEvents["AD_REWARDED"] = "onAdRewardGranted";
        AdEvents["BANNER_SHOWN"] = "onBannerShown";
        AdEvents["BANNER_HIDDEN"] = "onBannerHidden";
        AdEvents["AD_LOADED"] = "onAdLoaded";
        AdEvents["AD_PROVIDER_LOADED"] = "onAdProviderLoaded";
    })(AdEvents = exports.AdEvents || (exports.AdEvents = {}));
    var AdType;
    (function (AdType) {
        AdType[AdType["interstitial"] = 0] = "interstitial";
        AdType[AdType["rewarded"] = 1] = "rewarded";
        AdType[AdType["banner"] = 2] = "banner";
    })(AdType = exports.AdType || (exports.AdType = {}));
    var ProviderTypes;
    (function (ProviderTypes) {
        ProviderTypes["Yandex"] = "yx";
        ProviderTypes["Dummy"] = "dm";
        ProviderTypes["AdFree"] = "af";
        ProviderTypes["GD"] = "gd";
        ProviderTypes["GDBanner"] = "gdb";
        ProviderTypes["Jio"] = "jio";
    })(ProviderTypes = exports.ProviderTypes || (exports.ProviderTypes = {}));
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(34), __webpack_require__(12), __webpack_require__(563), __webpack_require__(766)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, eventemitter3_1, shared_1, standard_1, special_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", ({ value: true }));
    exports.AdWrapper = void 0;
    eventemitter3_1 = __importDefault(eventemitter3_1);
    var AdWrapper = /** @class */ (function (_super) {
        __extends(AdWrapper, _super);
        /**
         * Here we will create the ad provider
         *
         * @param type
         * @param id
         */
        function AdWrapper(type, id, jioConfig) {
            var _this = _super.call(this) || this;
            _this.bannerActive = false;
            _this.provider = null;
            switch (type) {
                case shared_1.ProviderTypes.AdFree:
                    _this.provider = new standard_1.AdFreeUntrackedProvider();
                    break;
                case shared_1.ProviderTypes.Dummy:
                    _this.provider = new standard_1.DummyProvider();
                    break;
                case shared_1.ProviderTypes.Yandex:
                    _this.provider = new standard_1.YandexAdProvider();
                    break;
                case shared_1.ProviderTypes.Jio:
                    _this.provider = new special_1.JioAdProvider(jioConfig);
                    break;
                default:
                case shared_1.ProviderTypes.GD:
                    _this.provider = new standard_1.GameDistribution(id);
                    break;
            }
            _this.provider.setManager(_this);
            return _this;
        }
        /**
         * Here we request an ad, the arguments passed depend on the provider used!
         * @param adType
         * @param args
         */
        AdWrapper.prototype.showAd = function (adType) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (null === this.provider) {
                throw new Error('Can not request an ad without an provider, please attach an ad provider!');
            }
            args.unshift(adType);
            this.provider.showAd.apply(this.provider, args);
        };
        AdWrapper.prototype.createBanner = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return this.provider.loadBanner.apply(this.provider, args);
        };
        AdWrapper.prototype.loadBanner = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (typeof this.provider.loadBanner === 'function') {
                return this.provider.loadBanner.apply(this.provider, args);
            }
            return null;
        };
        /**
         * Some providers might require you to preload an ad before showing it, that can be done here
         *
         * @param adType
         * @param args
         */
        AdWrapper.prototype.preloadAd = function (adType) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (null === this.provider) {
                throw new Error('Can not preload an ad without an provider, please attach an ad provider!');
            }
            args.unshift(adType);
            this.provider.preloadAd.apply(this.provider, args);
        };
        /**
         * Some providers require you to destroy an add after it was shown, that can be done here.
         *
         * @param adType
         * @param args
         */
        AdWrapper.prototype.destroyAd = function (adType) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (null === this.provider) {
                throw new Error('Can not destroy an ad without an provider, please attach an ad provider!');
            }
            args.unshift(adType);
            this.provider.destroyAd.apply(this.provider, args);
        };
        /**
         * Some providers allow you to hide an ad, you might think of an banner ad that is shown in show cases
         *
         * @param adType
         * @param args
         */
        AdWrapper.prototype.hideAd = function (adType) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (null === this.provider) {
                throw new Error('Can not hide an ad without an provider, please attach an ad provider!');
            }
            args.unshift(adType);
            this.provider.hideAd.apply(this.provider, args);
        };
        /**
         * Checks if ads are enabled or blocked
         */
        AdWrapper.prototype.adsEnabled = function () {
            if (null === this.provider) {
                throw new Error('Can not hide an ad without an provider, please attach an ad provider!');
            }
            return this.provider.adsEnabled;
        };
        /**
         * Checks if ads are enabled or blocked
         *
         * @param adType
         * @param args
         */
        AdWrapper.prototype.adAvailable = function (adType) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (null === this.provider) {
                throw new Error('Can not hide an ad without an provider, please attach an ad provider!');
            }
            args.unshift(adType);
            return this.provider.adAvailable.apply(this.provider, args);
        };
        return AdWrapper;
    }(eventemitter3_1.default));
    exports.AdWrapper = AdWrapper;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(729);
/******/ 	self.h5ads = __webpack_exports__;
/******/ 	
/******/ })()
;